// Salesforce record links, the way the Municipalities, Contacts and Departments screens build them.
const BASE = 'https://hejdevdoo.lightning.force.com/lightning/r'

export function sfAccountUrl(id) {
	return id ? `${BASE}/Account/${id}/view` : null
}

export function sfContactUrl(id) {
	return id ? `${BASE}/Contact/${id}/view` : null
}
